module.exports = __webpack_public_path__ + "img/payout.2aede130.svg";